/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run  } from './SkyBox';

run(document.getElementById('viewer'));
